(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5669],{

/***/ 87457:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/suport-clienti/cauta",
      function () {
        return __webpack_require__(12822);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 23751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11752);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73510);





var ref = (0,next_config__WEBPACK_IMPORTED_MODULE_2__["default"])(), settings = ref.publicRuntimeConfig.settings;
var TopArticles = function(param) {
    var items = param.items;
    if (!items || !items.length) {
        return null;
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: "Cele mai citite articole de suport",
                as: "h2",
                display: "h1",
                classesProp: "mb-1 lg:mb-2 -tracking-0.5 lg:-tracking-0.67 leading-30 lg:leading-normal"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-wrap -ml-3 overflow-hidden",
                children: items.map(function(item) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_3__["default"], {
                        href: "".concat(settings.baseUrl, "/suport-clienti/").concat(item.categories[0].slug, "/"),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                            className: "block w-auto ml-3 mt-3 py-10px px-5 rounded-bl-lg rounded-tr-lg bg-white border border-newsletterYellow-dark",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-newGray-mildDark text-sm font-medium leading-18.2 -tracking-0.29",
                                    style: {
                                        marginBottom: "6px"
                                    },
                                    children: item.categories[0].name
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "leading-20.8",
                                    children: item.title
                                })
                            ]
                        })
                    }, item.title);
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TopArticles);


/***/ }),

/***/ 12822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9008);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26209);
/* harmony import */ var _components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61167);
/* harmony import */ var _store_support_actions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3697);
/* harmony import */ var _containers_Support_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(72998);
/* harmony import */ var _components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(94512);
/* harmony import */ var _components_Heading__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(73510);
/* harmony import */ var _containers_ErrorPage__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(75720);
/* harmony import */ var _containers_Support_ArticleCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34611);
/* harmony import */ var _containers_Support_TopArticles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23751);













function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
var SupportSearchPage = /*#__PURE__*/ function(Component1) {
    "use strict";
    _inherits(SupportSearchPage, Component1);
    var _super = _createSuper(SupportSearchPage);
    function SupportSearchPage() {
        _classCallCheck(this, SupportSearchPage);
        return _super.apply(this, arguments);
    }
    _createClass(SupportSearchPage, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, searchParams = _props.searchParams, supportCategories = _props.supportCategories, supportSearchArticles = _props.supportSearchArticles, topSupportArticles = _props.topSupportArticles;
                if (!Object.keys(searchParams).length) {
                    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_ErrorPage__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        layout: "404"
                    }));
                }
                var word = searchParams.qs, tag = searchParams.ts;
                var pageHeading = "Rezultate cautare : ".concat(word || tag);
                return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_head__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                                children: pageHeading
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            breadcrumbs: [
                                {
                                    id: 1,
                                    level: 2,
                                    name: "Suport clienti",
                                    url_key: "suport-clienti/"
                                },
                                {
                                    id: 1,
                                    level: 99,
                                    name: "Rezultate cautare"
                                }, 
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Support_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            categories: supportCategories,
                            hasTitle: false,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
                                className: "py-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: "mb-6",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Heading__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            title: pageHeading,
                                            as: "h1",
                                            display: "h1"
                                        })
                                    }),
                                    supportSearchArticles && supportSearchArticles.length ? supportSearchArticles.map(function(item) {
                                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Support_ArticleCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                            item: item,
                                            articleSlug: item.slug
                                        }, item.slug);
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: "mt-3 Alert",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                                                    children: "Nu au fost gasite rezultate. In schimb, acestea sunt cele mai citite articole de suport:"
                                                })
                                            }),
                                            topSupportArticles && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                                                className: "pt-12",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Support_TopArticles__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    items: topSupportArticles
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }));
            }
        }
    ]);
    return SupportSearchPage;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
SupportSearchPage.pageLayout = "default";
SupportSearchPage.getInitialProps = (function() {
    var _ref = _asyncToGenerator(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(ctx) {
        var reduxStore, query, qs, ts, searchParams, _support, categories, topArticles, searchArticles, promises;
        return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    reduxStore = ctx.reduxStore, query = ctx.query;
                    qs = query.qs, ts = query.ts;
                    searchParams = qs && {
                        qs: qs
                    } || ts && {
                        ts: ts
                    } || {};
                    _support = reduxStore.getState().support, categories = _support.categories, topArticles = _support.topArticles, searchArticles = _support.searchArticles;
                    promises = [];
                    // Load data
                    !categories && promises.push(reduxStore.dispatch((0,_store_support_actions__WEBPACK_IMPORTED_MODULE_6__/* .getSupportCategories */ .eU)()));
                    promises.push(reduxStore.dispatch((0,_store_support_actions__WEBPACK_IMPORTED_MODULE_6__/* .getSupportSearchArticles */ .i_)(searchParams)));
                    if (!searchArticles || !searchArticles.length || !topArticles) {
                        promises.push(reduxStore.dispatch((0,_store_support_actions__WEBPACK_IMPORTED_MODULE_6__/* .getSupportIndex */ .ck)()));
                    }
                    _ctx.next = 10;
                    return Promise.all(promises);
                case 10:
                    return _ctx.abrupt("return", {
                        searchParams: searchParams
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function(ctx) {
        return _ref.apply(this, arguments);
    };
})();
/* harmony default export */ __webpack_exports__["default"] = ((0,_components_withRouterPageLayout_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .connect */ .$j)(function(state) {
    return {
        supportCategories: state.support.categories,
        supportSearchArticles: state.support.searchArticles,
        topSupportArticles: state.support.topArticles
    };
})(SupportSearchPage)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1223,8768,9774,2888,179], function() { return __webpack_exec__(87457); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);